<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.5 15a.31.31 0 0 1-.116-.023L5.3 14.549a8.33 8.33 0 0 1-2.44-1.492 6.725 6.725 0 0 1-1.75-2.435L.886 10.1A8.391 8.391 0 0 1 .32 8.113 27.992 27.992 0 0 1 0 3.874v-.6A.717.717 0 0 1 .407 2.6L6.374.026a.322.322 0 0 1 .254 0L12.595 2.6a.717.717 0 0 1 .406.67v.957c0 .564-.02 1.134-.06 1.7A5 5 0 1 0 8.847 14a8.118 8.118 0 0 1-1.133.551l-1.092.428A.313.313 0 0 1 6.5 15Z" opacity=".45" fill="currentColor"/><path d="M8 15v-1.1A5.014 5.014 0 0 1 4.1 10H3a1 1 0 1 1 0-2h1.1A5.015 5.015 0 0 1 8 4.1V3a1 1 0 1 1 2 0v1.1A5.015 5.015 0 0 1 13.9 8H15a1 1 0 1 1 0 2h-1.1a5.015 5.015 0 0 1-3.9 3.9V15a1 1 0 1 1-2 0ZM6 9a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering146',
});
</script>
